import _objectSpread from "/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import router from "./router";
import store from "./store";
import Vue from 'vue';
import { Message } from 'element-ui';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { getToken } from '@/utils/auth';
NProgress.configure({
  showSpinner: false
});
var whiteList = ['/login', '/auth-redirect', '/bind', '/register', '/forgot', '/reset', '/switch'];
router.beforeEach(function (to, from, next) {
  NProgress.start();
  if (getToken()) {
    /* has token*/
    if (to.path === '/login') {
      next({
        path: '/'
      });
      NProgress.done();
    } else {
      if (store.getters.roles.length === 0) {
        // Vue.prototype.msgError('跳转页面错误角色')
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then(function (res) {
          // console.log(res)
          // 拉取user_info
          var roles = res.data.roles;
          store.dispatch('GenerateRoutes', {
            roles: roles
          }).then(function (accessRoutes) {
            router.addRoutes(accessRoutes); // 动态添加可访问路由表
            // Vue.prototype.msgError(to.path)
            next(_objectSpread(_objectSpread({}, to), {}, {
              replace: true
            })); // hack方法 确保addRoutes已完成
          });
        }).catch(function (err) {
          // Vue.prototype.msgError('跳转页面错误')
          store.dispatch('FedLogOut').then(function () {
            next({
              path: '/'
            });
          });
        });
      } else {
        next();
        // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        // if (hasPermission(store.getters.roles, to.meta.roles)) {
        //   next()
        // } else {
        //   next({ path: '/401', replace: true, query: { noGoBack: true }})
        // }
        // 可删 ↑
      }
    }
  } else {
    // 没有token
    // Vue.prototype.msgError('跳转页面错误token')
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
      // console.log(to.path)
    } else {
      // Vue.prototype.msgError('跳转页面错误token调到/login')
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      }); // 否则全部重定向到登录页
      NProgress.done();
    }
  }
});
router.afterEach(function () {
  NProgress.done();
});